// Actions related to API calls for studies
import axios from "axios";
import { serverURL } from "../../constants/constants";
import { viewIds } from "../../constants/componentMap";

// Import necessary calls from other files
import { setView, errorResponse } from "../../actions";

export function fetchLogin(loginData, rememberMe) {
  return function (dispatch) {
    dispatch(requestLogin());
    let req = {
      username: loginData.username,
      password: loginData.password,
    };

    console.log("POST request made for /user_login for username:", req);
    return axios.post(serverURL + "/user_login", req).then(
      (response) => {
        if (response.data.check) {
          dispatch(receiveLogin(loginData, response.data.remember_me_allowed));
          dispatch(setRememberMe(rememberMe));
          if (response.data.remember_me_allowed && rememberMe) {
            localStorage.setItem("username", loginData.username);
            localStorage.setItem("password", loginData.password);
          } else {
            localStorage.setItem("username", null);
            localStorage.setItem("password", null);
          }
          dispatch(setView(viewIds.startPage));
        } else {
          localStorage.setItem("username", null);
          localStorage.setItem("password", null);
          dispatch(resetLogin());
          dispatch(
            errorResponse({
              response: {
                data: { error: "Username or password is incorrect" },
              },
            })
          );
        }
      },
      (error) => dispatch(errorResponse(error))
    );
  };
}

export const SET_REMEMBER_ME = "SET_REMEMBER_ME";
export function setRememberMe(rememberMe) {
  return {
    type: SET_REMEMBER_ME,
    rememberMe,
  };
}

export const REQUEST_LOGIN = "REQUEST_LOGIN";
export function requestLogin() {
  return {
    type: REQUEST_LOGIN,
  };
}

export const RECEIVE_LOGIN = "RECEIVE_LOGIN";
export function receiveLogin(loginInfo, rememberMeAllowed) {
  return {
    type: RECEIVE_LOGIN,
    username: loginInfo.username,
    password: loginInfo.password,
    rememberMeAllowed,
  };
}

export const RESET_LOGIN = "RESET_LOGIN";
export function resetLogin() {
  return {
    type: RESET_LOGIN,
  };
}
